module.exports = __webpack_public_path__ + "files/0b34637cf0c273fc0de9e1c961017faf.png";